@if (hasDivider) {
  <rt-divider />
}
<div class="content">
  <div class="prefix-wrapper">
    <ng-content select="[prefix]" />
  </div>

  <div class="content-wrapper">
    <ng-content />
  </div>

  @if (href) {
    <a [href]="href" [target]="hrefTarget ? hrefTarget : '_self'"></a>
  }

  <div class="suffix-wrapper" layout-horizontal>
    <ng-content select="[suffix]" />

    @if (hasChevronRight) {
      <div>
        <rt-icon name="chevron-right" />
      </div>
    }

    @if (isSelected) {
      <div>
        <rt-icon class="check-icon" name="check" />
      </div>
    }
  </div>
</div>
